export default "__VITE_ASSET__Bobhcr9I__"